<template>
  <router-view :process="'default'" @changeSaveButton="$emit('changeSaveButton', $event)"></router-view>
</template>

<script>
export default {
  name: 'process'
}
</script>